module.exports = __webpack_public_path__ + "img/punch.bd5cc1ac.svg";